var _g, _path, _g2, _g3, _g4, _g5, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEveryMonthUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_14307_39283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.54518 15.8589C5.47825 15.573 4.36976 16.2059 4.20393 17.2979C3.68353 20.7251 4.16213 24.2454 5.60445 27.4287C7.32313 31.2219 10.3039 34.3018 14.0388 36.1437C17.7737 37.9856 22.0318 38.4754 26.0874 37.5298C30.143 36.5841 33.7452 34.2615 36.2804 30.9577C38.8155 27.6539 40.1266 23.5732 39.9904 19.4111C39.8541 15.2489 38.2789 11.2627 35.5331 8.13178C32.7873 5.00082 29.0409 2.91878 24.9321 2.24042C21.484 1.67113 17.9598 2.11997 14.784 3.50967C13.7721 3.95249 13.4477 5.18701 14 6.14359L15.8853 9.40902C16.4376 10.3656 17.6582 10.6721 18.7038 10.3162C20.2894 9.77649 21.9936 9.63106 23.6663 9.90722C26.0013 10.2927 28.1305 11.476 29.6909 13.2553C31.2513 15.0346 32.1465 17.2999 32.2239 19.6653C32.3014 22.0307 31.5562 24.3497 30.1155 26.2273C28.6748 28.1048 26.6277 29.4248 24.3229 29.9622C22.0181 30.4996 19.5982 30.2212 17.4756 29.1745C15.3531 28.1277 13.6591 26.3774 12.6824 24.2217C11.9827 22.6775 11.6821 20.9938 11.793 19.3225C11.8662 18.2203 11.2542 17.1207 10.1873 16.8348L6.54518 15.8589Z",
    fill: "url(#paint0_linear_14307_39283)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.72318 20L14.2768 20C15.0446 20 15.526 19.1705 15.1451 18.5039L8.86824 7.51943C8.48435 6.84761 7.51565 6.84761 7.13176 7.51942L0.854936 18.5039C0.47399 19.1705 0.955357 20 1.72318 20Z",
    fill: "#FF7A00"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_14307_39283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 48C16 50.2091 17.7909 52 20 52H48C50.2091 52 52 50.2091 52 48V28C52 26.8954 51.1046 26 50 26H18C16.8954 26 16 26.8954 16 28V48Z",
    fill: "url(#paint1_linear_14307_39283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 48C16 50.2091 17.7909 52 20 52H48C50.2091 52 52 50.2091 52 48V28C52 26.8954 51.1046 26 50 26H18C16.8954 26 16 26.8954 16 28V48Z",
    fill: "url(#paint2_radial_14307_39283)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 48C16.5 49.933 18.067 51.5 20 51.5H48C49.933 51.5 51.5 49.933 51.5 48V28C51.5 27.1716 50.8284 26.5 50 26.5H18C17.1716 26.5 16.5 27.1716 16.5 28V48Z",
    stroke: "url(#paint3_radial_14307_39283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 48C16.5 49.933 18.067 51.5 20 51.5H48C49.933 51.5 51.5 49.933 51.5 48V28C51.5 27.1716 50.8284 26.5 50 26.5H18C17.1716 26.5 16.5 27.1716 16.5 28V48Z",
    stroke: "url(#paint4_radial_14307_39283)",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 48C16.5 49.933 18.067 51.5 20 51.5H48C49.933 51.5 51.5 49.933 51.5 48V28C51.5 27.1716 50.8284 26.5 50 26.5H18C17.1716 26.5 16.5 27.1716 16.5 28V48Z",
    stroke: "url(#paint5_radial_14307_39283)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_14307_39283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 23C15 24.1046 15.8954 25 17 25H51C52.1046 25 53 24.1046 53 23V21V19C53 17.8954 52.1046 17 51 17H45C43.8954 17 43 17.8954 43 19C43 20.1046 42.1046 21 41 21C39.8954 21 39 20.1046 39 19C39 17.8954 38.1046 17 37 17H31C29.8954 17 29 17.8954 29 19C29 20.1046 28.1046 21 27 21C25.8954 21 25 20.1046 25 19C25 17.8954 24.1046 17 23 17H17C15.8954 17 15 17.8954 15 19V21V23Z",
    fill: "url(#paint6_linear_14307_39283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 23C15 24.1046 15.8954 25 17 25H51C52.1046 25 53 24.1046 53 23V21V19C53 17.8954 52.1046 17 51 17H45C43.8954 17 43 17.8954 43 19C43 20.1046 42.1046 21 41 21C39.8954 21 39 20.1046 39 19C39 17.8954 38.1046 17 37 17H31C29.8954 17 29 17.8954 29 19C29 20.1046 28.1046 21 27 21C25.8954 21 25 20.1046 25 19C25 17.8954 24.1046 17 23 17H17C15.8954 17 15 17.8954 15 19V21V23Z",
    fill: "url(#paint7_radial_14307_39283)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 23C15.5 23.8284 16.1716 24.5 17 24.5H51C51.8284 24.5 52.5 23.8284 52.5 23V21V19C52.5 18.1716 51.8284 17.5 51 17.5H45C44.1716 17.5 43.5 18.1716 43.5 19C43.5 20.3807 42.3807 21.5 41 21.5C39.6193 21.5 38.5 20.3807 38.5 19C38.5 18.1716 37.8284 17.5 37 17.5H31C30.1716 17.5 29.5 18.1716 29.5 19C29.5 20.3807 28.3807 21.5 27 21.5C25.6193 21.5 24.5 20.3807 24.5 19C24.5 18.1716 23.8284 17.5 23 17.5H17C16.1716 17.5 15.5 18.1716 15.5 19V21V23Z",
    stroke: "url(#paint8_radial_14307_39283)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_14307_39283)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 13,
    width: 4,
    height: 8,
    rx: 2,
    fill: "white",
    fillOpacity: 0.3
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_b_14307_39283)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 13,
    width: 4,
    height: 8,
    rx: 2,
    fill: "white",
    fillOpacity: 0.3
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2443 46.1591C29.3958 46.1591 28.6402 46.0133 27.9773 45.7216C27.3182 45.4261 26.7973 45.0208 26.4148 44.5057C26.036 43.9867 25.8409 43.3883 25.8295 42.7102H28.3068C28.322 42.9943 28.4148 43.2443 28.5852 43.4602C28.7595 43.6723 28.9905 43.8371 29.2784 43.9545C29.5663 44.072 29.8902 44.1307 30.25 44.1307C30.625 44.1307 30.9564 44.0644 31.2443 43.9318C31.5322 43.7992 31.7576 43.6155 31.9205 43.3807C32.0833 43.1458 32.1648 42.875 32.1648 42.5682C32.1648 42.2576 32.0777 41.983 31.9034 41.7443C31.733 41.5019 31.4867 41.3125 31.1648 41.1761C30.8466 41.0398 30.4678 40.9716 30.0284 40.9716H28.9432V39.1648H30.0284C30.3996 39.1648 30.7273 39.1004 31.0114 38.9716C31.2992 38.8428 31.5227 38.6648 31.6818 38.4375C31.8409 38.2064 31.9205 37.9375 31.9205 37.6307C31.9205 37.339 31.8504 37.0833 31.7102 36.8636C31.5739 36.6402 31.3807 36.4659 31.1307 36.3409C30.8845 36.2159 30.5966 36.1534 30.267 36.1534C29.9337 36.1534 29.6288 36.214 29.3523 36.3352C29.0758 36.4527 28.8542 36.6212 28.6875 36.8409C28.5208 37.0606 28.4318 37.3182 28.4205 37.6136H26.0625C26.0739 36.9432 26.2652 36.3523 26.6364 35.8409C27.0076 35.3295 27.5076 34.9299 28.1364 34.642C28.7689 34.3504 29.483 34.2045 30.2784 34.2045C31.0814 34.2045 31.7841 34.3504 32.3864 34.642C32.9886 34.9337 33.4564 35.3277 33.7898 35.8239C34.1269 36.3163 34.2936 36.8693 34.2898 37.483C34.2936 38.1345 34.0909 38.678 33.6818 39.1136C33.2765 39.5492 32.7481 39.8258 32.0966 39.9432V40.0341C32.9527 40.1439 33.6042 40.4413 34.0511 40.9261C34.5019 41.4072 34.7254 42.0095 34.7216 42.733C34.7254 43.3958 34.5341 43.9848 34.1477 44.5C33.7652 45.0152 33.2367 45.4205 32.5625 45.7159C31.8883 46.0114 31.1155 46.1591 30.2443 46.1591ZM41.5526 34.3636V46H39.0923V36.6989H39.0241L36.3594 38.3693V36.1875L39.2401 34.3636H41.5526Z",
    fill: "#88A2B1",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2443 45.1591C28.3958 45.1591 27.6402 45.0133 26.9773 44.7216C26.3182 44.4261 25.7973 44.0208 25.4148 43.5057C25.036 42.9867 24.8409 42.3883 24.8295 41.7102H27.3068C27.322 41.9943 27.4148 42.2443 27.5852 42.4602C27.7595 42.6723 27.9905 42.8371 28.2784 42.9545C28.5663 43.072 28.8902 43.1307 29.25 43.1307C29.625 43.1307 29.9564 43.0644 30.2443 42.9318C30.5322 42.7992 30.7576 42.6155 30.9205 42.3807C31.0833 42.1458 31.1648 41.875 31.1648 41.5682C31.1648 41.2576 31.0777 40.983 30.9034 40.7443C30.733 40.5019 30.4867 40.3125 30.1648 40.1761C29.8466 40.0398 29.4678 39.9716 29.0284 39.9716H27.9432V38.1648H29.0284C29.3996 38.1648 29.7273 38.1004 30.0114 37.9716C30.2992 37.8428 30.5227 37.6648 30.6818 37.4375C30.8409 37.2064 30.9205 36.9375 30.9205 36.6307C30.9205 36.339 30.8504 36.0833 30.7102 35.8636C30.5739 35.6402 30.3807 35.4659 30.1307 35.3409C29.8845 35.2159 29.5966 35.1534 29.267 35.1534C28.9337 35.1534 28.6288 35.214 28.3523 35.3352C28.0758 35.4527 27.8542 35.6212 27.6875 35.8409C27.5208 36.0606 27.4318 36.3182 27.4205 36.6136H25.0625C25.0739 35.9432 25.2652 35.3523 25.6364 34.8409C26.0076 34.3295 26.5076 33.9299 27.1364 33.642C27.7689 33.3504 28.483 33.2045 29.2784 33.2045C30.0814 33.2045 30.7841 33.3504 31.3864 33.642C31.9886 33.9337 32.4564 34.3277 32.7898 34.8239C33.1269 35.3163 33.2936 35.8693 33.2898 36.483C33.2936 37.1345 33.0909 37.678 32.6818 38.1136C32.2765 38.5492 31.7481 38.8258 31.0966 38.9432V39.0341C31.9527 39.1439 32.6042 39.4413 33.0511 39.9261C33.5019 40.4072 33.7254 41.0095 33.7216 41.733C33.7254 42.3958 33.5341 42.9848 33.1477 43.5C32.7652 44.0152 32.2367 44.4205 31.5625 44.7159C30.8883 45.0114 30.1155 45.1591 29.2443 45.1591ZM40.5526 33.3636V45H38.0923V35.6989H38.0241L35.3594 37.3693V35.1875L38.2401 33.3636H40.5526Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_14307_39283",
    x: 0,
    y: -2,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14307_39283"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14307_39283",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_14307_39283",
    x: 4,
    y: 14,
    width: 60,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14307_39283"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14307_39283",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_14307_39283",
    x: 7,
    y: 9,
    width: 54,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14307_39283"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14307_39283",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_14307_39283",
    x: 19,
    y: 7,
    width: 16,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14307_39283"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14307_39283",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_14307_39283",
    x: 33,
    y: 7,
    width: 16,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14307_39283"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14307_39283",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14307_39283",
    x1: 4,
    y1: 38,
    x2: 40,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14307_39283",
    x1: 16,
    y1: 52,
    x2: 26.3823,
    y2: 23.2491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_14307_39283",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16 52) scale(36 26)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_14307_39283",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.5 35.0278) rotate(-4.42478) scale(14.0419 10.1967)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_14307_39283",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.5 47.3056) rotate(-144.162) scale(5.5509 23.2933)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_14307_39283",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.5 46.9444) rotate(-124.695) scale(13.1762 15.4161)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_14307_39283",
    x1: 10.7778,
    y1: 25,
    x2: 11.6327,
    y2: 15.0736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_14307_39283",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.7778 25) scale(46.4444 8)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_14307_39283",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.0833 25) rotate(-90) scale(6 18.8515)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEveryMonthUpdate);
export default __webpack_public_path__ + "static/media/every-month-update.18cc4867eeeff9adef33d892395c4df0.svg";
export { ForwardRef as ReactComponent };